import { useMemo } from 'react';

import type { IIRevResultState } from '../../../interface/state/IRev';
import Chart from '../../utils/chart';
import TabMessage from '../child-agent/tabs/TabMessage';
import { DocIcon, KpiMatrix, PartyBars, SummaryGrid } from './components';
import { buildChartData, computeKpis, sortedParties } from './utils';

/**
 * "Results & Analytics" — the data the agent actually entered: the 7 recorded
 * figures, a derived-KPI matrix, color-coded party bars, and a party-vote column
 * chart. All computed from the already-loaded result (no extra fetch).
 */
const ResultDataTab = ({ result }: { result: IIRevResultState }) => {
	const kpis = useMemo(() => computeKpis(result), [result]);
	const parties = useMemo(() => sortedParties(result), [result]);
	const chartData = useMemo(() => buildChartData(result), [result]);

	const hasFigures = !!(result.votersOnRegister || result.accreditedVoters || result.totalValidVotes || parties.length);

	if (!hasFigures) {
		return (
			<TabMessage
				icon={<DocIcon />}
				tone='neutral'
				title='No result data recorded'
				hint='Voter figures and party votes for this submission are not available.'
			/>
		);
	}

	return (
		<div className='ca-result f-column-23'>
			<SummaryGrid result={result} />
			<KpiMatrix kpis={kpis} />
			<PartyBars
				result={result}
				kpis={kpis}
			/>
			{parties.length ? (
				<div className='vsr-section'>
					<span className='ca-result__section-title'>Vote distribution</span>
					<div className='vsr-chart'>
						<Chart
							categories={chartData.categories}
							dataset={chartData.dataset}
						/>
					</div>
				</div>
			) : null}
		</div>
	);
};

export default ResultDataTab;
